// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer_jYmXqkJN","wording":"wording_BntwYkI0"};